import { toast } from "react-toastify";

import { UploadCogsDataRequestBodyType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const uploadCogsData = async (data: UploadCogsDataRequestBodyType) => {
  const resp = await api.post<string>(`/v2/organizations/upload-cogs-data`, {
    ...data,
  });
  return resp.data;
};

export const useUploadCogsData = () => {
  return useMutation({
    mutationFn: async (data: UploadCogsDataRequestBodyType) =>
      uploadCogsData(data),
    onSuccess: () => {
      toast.success(
        "Your COGS data has been uploaded, please wait 60 minutes for data to appear in analytics."
      );
    },
  });
};
